<ng-template #loading_stages>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>


<glo-stages-crud></glo-stages-crud>
<glo-stages-menu *ngIf="stagesList$ | async as stagesList; else loading_stages" [stagesList]='stagesList'>
</glo-stages-menu>